import { types } from 'mobx-state-tree'

export const GameResult = types
  .model('GameResult')
  .props({
    status: types.optional(
      types.enumeration(['idle', 'pending', 'pending-adaptive', 'done', 'error', 'ready']),
      'idle',
    ),
    id: types.identifierNumber,
    answered: types.number,
    correct_answers: types.number,
  })
  .actions((self) => ({
    setStatus(value?: 'idle' | 'pending' | 'done' | 'error') {
      self.status = value || 'idle'
    },
  }))
  .views((self) => ({
    get loading() {
      return self.status === 'pending'
    },
  }))
  .actions((self) => ({}))
